import React from "react";

const ModalEquiposBitacora = ({
  onOpenChange,
  handleSubmit,
  handleChange,
  values,
  handleFileChange,
}) => {
  const {
    nro_dcto,
    fecha,
    comprobante,
    lugar,
    estanque,
    cuenta_litros_inicial,
    cuenta_litros_final,
    cantidad,
  } = values;

  return (
    <>
      <div className="container-modal" onClick={onOpenChange}></div>
      <div className="body-modal">
        <h6>Agregar datos</h6>
        <div className="row">
          <div className="col-md-4">
            <label className="label-title mt-2 mb-2">Nro Documento</label>
            <input
              name="nro_dcto"
              value={nro_dcto}
              onChange={handleChange}
              className="inputRegistros"
              placeholder="Ingrese nro documento"
            />
          </div>
          <div className="col-md-4">
            <label className="label-title mt-2 mb-2">Fecha</label>
            <input
              name="fecha"
              value={fecha}
              onChange={handleChange}
              className="inputRegistros"
              placeholder="Ingrese fecha"
              type="datetime-local"
            />
          </div>
          <div className="col-md-4">
            <label className="label-title mt-2 mb-2">Lugar</label>
            <input
              name="lugar"
              value={lugar}
              onChange={handleChange}
              className="inputRegistros"
              placeholder="Ingrese lugar"
            />
          </div>

          <div className="col-md-4">
            <label className="label-title mt-2 mb-2">
              Cuenta Litros Inicial
            </label>
            <input
              name="cuenta_litros_inicial"
              value={cuenta_litros_inicial}
              onChange={handleChange}
              className="inputRegistros"
              placeholder="Ingrese cuenta litros inicial"
              type="number"
            />
          </div>
          <div className="col-md-4">
            <label className="label-title mt-2 mb-2">Cuenta Litros Final</label>
            <input
              name="cuenta_litros_final"
              value={cuenta_litros_final}
              onChange={handleChange}
              className="inputRegistros"
              placeholder="Ingrese cuenta litros final"
              type="number"
            />
          </div>
          <div className="col-md-4">
            <label className="label-title mt-2 mb-2">Cantidad</label>
            <input
              name="cantidad"
              value={cuenta_litros_final - cuenta_litros_inicial}
              // onChange={handleChange}

              className="inputRegistros"
              placeholder="Ingrese cantidad"
              readOnly={true}
            />
          </div>

          <div className="col-md-12 ">
            <label className="label-title mt-2 mb-2">Comprobante</label>
            <input
              name="comprobante"
              type="file"
              onChange={handleFileChange}
              className="inputRegistros"
              placeholder="Comprobante"
              accept="image/*"
            />
            {comprobante && (
              <img
                src={comprobante}
                alt="Comprobante Preview"
                style={{ width: "100px", height: "100px" }}
              />
            )}
          </div>

          <button
            className="buttonContentSecondary w-100 mt-2"
            onClick={handleSubmit}
          >
            Agregar Registro
          </button>
        </div>
      </div>
    </>
  );
};

export default ModalEquiposBitacora;
